module.exports = __webpack_public_path__ + "img/box6_img1.aa0e4d33.jpg";